module.exports = __webpack_public_path__ + "static/logo1-820a9c9ea542e472ade968bcd0576267.jpg";